import React from 'react';
import PropTypes from 'prop-types';

import { QuestionIcon } from 'assets/icons';

import { getDefaultColor, toPixels } from 'styles/theme';

import { TooltipContainer, TooltipText } from './styles';

const Tooltip = ({
  text,
  maw,
  icon,
  position,
  align,
}) => {
  const Icon = icon || <QuestionIcon fill={getDefaultColor('metallic')} />;

  return (
    <TooltipContainer>
      {Icon}

      <TooltipText data-tooltip-text="true" maw={toPixels(maw)} position={position} align={align}>
        {text}
      </TooltipText>
    </TooltipContainer>
  );
};

Tooltip.propTypes = {
  maw: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string.isRequired,
  icon: PropTypes.element,
  position: PropTypes.oneOf(['top', 'bottom']),
  align: PropTypes.oneOf(['start', 'center', 'end']),
};

Tooltip.defaultProps = {
  maw: 300,
  icon: null,
  position: 'bottom',
  align: 'center',
};

export default Tooltip;
